import ScoringList from "../../components/scoring/ScoringList"

export const ScoringPage = () => {

    return (
        <ScoringList></ScoringList>
    )
}